export default __webpack_public_path__ + "static/media/enghien04.55129fa5.jpg";